import { render, staticRenderFns } from "./ReportFooter.vue?vue&type=template&id=21d85d94&scoped=true"
import script from "./ReportFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReportFooter.vue?vue&type=style&index=0&id=21d85d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d85d94",
  null
  
)

export default component.exports